import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Font Awesome (componente Vue)
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';

library.add(faPhone, faEnvelope, faMapMarkerAlt, faClock, faFacebook, faInstagram, faWhatsapp, faLinkedin);

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.mount('#app');
